module.exports = __webpack_public_path__ + "img/QLT-Benefit-Icon_1_21x21.57570c2b.svg";